export const kgVariations = [
    'kg',
    'kgs',
    'kilogram',
    'kilograms'
];

export const gramVariations = [
    'g',
    'gram',
    'grams',
    'gm',
    'gms',
    'grm',
    'grms'
];

export const literVariations = [
    'l',
    'ltr',
    'ltrs',
    'liter',
    'liters',
    'litre',
    'litres'
];

export const milliliterVariations = [
    'ml',
    'milliliter',
    'milliliters',
    'millilitre',
    'millilitres',
    'mls'
];

export const unitVariations = {
    kg: kgVariations,
    gram: gramVariations,
    liter: literVariations,
    milliliter: milliliterVariations
};